howspace.manager = {};
